import React, { Component } from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import routes from '../../../routes';
import './layout.css'
import Header from '../Header/header'
import Footer from '../Footer/footer'
import { Col, Row, Container } from 'reactstrap'
import SideMenu from '../SideMenu/sideMenu'
import { changeLang, IntializeToken } from '../../../Redux/Action/LoginAction'
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import LoadingBar from 'react-redux-loading-bar'
import { initStatus } from '../../../Redux/Action/SocketAction'

class Layout extends Component {
  componentDidMount() {
    
  }
  componentWillMount() {
    this.props.initStatus()
    let lang = localStorage.getItem("JazanLanguage") ? JSON.parse(localStorage.getItem("JazanLanguage")) : null
    console.log("ggggggggggg lang", lang, localStorage.getItem("JazanLanguage") ? JSON.parse(localStorage.getItem("JazanLanguage")) : "ar", localStorage.getItem("JazanLanguage"))
    let user = localStorage.getItem("JAZANuser") ? JSON.parse(localStorage.getItem("JAZANuser")) : null
    let token= localStorage.getItem("JAZANtoken") ? JSON.parse(localStorage.getItem("JAZANtoken")) : null
    if (lang) {
      console.log("lang in if", lang)
      this.props.changeLang(lang)
    } else {
      console.log("lang in else if", lang, "ar")
      this.props.changeLang("ar")
    }
    if (!this.props.user) {
      if (user) {
        this.props.IntializeToken(token,lang,user)
        console.log("refresh in this page")
      }
    }
  }
  render() {
    return (
      <div>
        <div className="loading-bar" >
          <LoadingBar style={{ height: '5px', zIndex: 1250, backgroundColor: "#023619" }} />
        </div>
        <Container fluid>
          <Row>
            <Col lg="9" className="px-0">
              <Header />
              <div style={{ height: "95%", }} className="layoutDefault">
                <Switch>
                  {routes.map((route, idx) => {
                    return route.component ? (<Route key={idx} path={route.path} exact={route.exact} name={route.name} render={props => (
                      <route.component {...props} />
                    )} />)
                      : (null);
                  },
                  )}
                  {/* <Redirect from="/" to="/Magazin" /> */}
                </Switch>
              </div>
            </Col>
            <Col lg="3" className="menuScreen px-0">
              <SideMenu />
            </Col>
            <Footer />
          </Row>
        </Container>
      </div>
    )
  }
}
const mapStateToProps = state => {
  return {
    lang: state.login.language,
    user: state.login.user,
    screenType: state.login.screentype
  }
}
const mapDispatchToProps = dispatch => bindActionCreators(
  {
    changeLang,
    IntializeToken,
    initStatus
  }
  , dispatch
)
export default connect(mapStateToProps, mapDispatchToProps)(Layout);